import { Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import {
  consumableSupply_pack,
  consumableSupply_rolls,
} from '../../../../../../../data/forms/nrc/consumableSupplyDropdownOptions.js';

export default function MississippiSupplySelectForm({
  supplySelections,
  setForm,
}) {
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prevForm => ({
      ...prevForm,
      supplySelections: {
        ...prevForm.supplySelections,
        [name]: value,
      },
    }));
  };

  return (
    <>
      <Grid size={6}>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Cash 3 Playslip'}</InputLabel>
          <Select
            value={supplySelections.cash3}
            label={'Cash 3 Playslip'}
            onChange={handleChange}
            name='cash3'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Cash 4 Playslip'}</InputLabel>
          <Select
            value={supplySelections.cash4}
            label={'Cash 4 Playslip'}
            onChange={handleChange}
            name='cash4'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Cash Pop Playslip'}</InputLabel>
          <Select
            value={supplySelections.cashPop}
            label={'Cash Pop Playslip'}
            onChange={handleChange}
            name='cashPop'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Lotto America Playslip'}</InputLabel>
          <Select
            value={supplySelections.lottoAmerica}
            label={'Lotto America Playslip'}
            onChange={handleChange}
            name='lottoAmerica'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Match 5 Playslip'}</InputLabel>
          <Select
            value={supplySelections.match5}
            label={'Match 5 Playslip'}
            onChange={handleChange}
            name='match5'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={6}>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Mega Millions Playslip'}</InputLabel>
          <Select
            value={supplySelections.megaMillions}
            label={'Mega Millions Playslip'}
            onChange={handleChange}
            name='megaMillions'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Millionaire For Life Playslip'}</InputLabel>
          <Select
            value={supplySelections.millionaireForLife}
            label={'Millionaire For Life Playslip'}
            onChange={handleChange}
            name='millionaireForLife'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Powerball Playslip'}</InputLabel>
          <Select
            value={supplySelections.powerball}
            label={'Powerball Playslip'}
            onChange={handleChange}
            name='powerball'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Ticket Stock (Printer Paper)'}</InputLabel>
          <Select
            value={supplySelections.ticketStock}
            label={'Ticket Stock (Printer Paper)'}
            onChange={handleChange}
            name='ticketStock'
          >
            {consumableSupply_rolls.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </>
  );
}
